import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Footer.css'; // Импортируем стили

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <footer className="footer">
            <div className="footer-links">
                <Link 
                    to="/privacy-policy" 
                    className={currentPath === '/privacy-policy' ? 'footer-link active' : 'footer-link'}
                >
                    ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ
                </Link>
                <Link 
                    to="/user-agreement" 
                    className={currentPath === '/user-agreement' ? 'footer-link active' : 'footer-link'}
                >
                    ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ
                </Link>
                <Link 
                    to="/about" 
                    className={currentPath === '/about' ? 'footer-link active' : 'footer-link'}
                >
                    О ПРОЕКТЕ
                </Link>
                <Link 
                    to="/contacts" 
                    className={currentPath === '/contacts' ? 'footer-link active' : 'footer-link'}
                >
                    КОНТАКТЫ
                </Link>
                <Link 
                    to="/feedback" 
                    className={currentPath === '/feedback' ? 'footer-link active' : 'footer-link'}
                >
                    <strong>НАПИШИТЕ НАМ!</strong>
                </Link>
            </div>
            <p className="footer-year">#Хочувлето© {currentYear}</p>
        </footer>
    );
};

export default Footer;
